export default {
  title: 'Looking for specific information?',
  placeholder: 'Ask a question to get a quick response from our AI',
  response: {
    requestError: 'Sorry, we could not process your request. Please try again.',
  },
  suggestions: {
    caregiverDuration: 'How long will it take to find a caregiver?',
    earliestStartDay: 'Earliest start day?',
  },
};
